import React from "react";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { NoData } from "../../../components/NoData";
import { useSelector } from "../../../store/hooks";
import { Label, Row } from "./RecommendationPanel";

export const MainCategoryCode = () => {
  const { t } = useTranslation();
  const loadRecommendationStatus = useSelector(
    (s) => s.recommendationPanel.loadRecommendationStatus
  );
  const recommendation = useSelector(
    (s) => s.recommendationPanel.recommendation
  );
  const taxonomy = useSelector((s) => s.taxonomy);
  const isLoading = loadRecommendationStatus === "loading";

  let render;
  if (isLoading) render = <Skeleton width={150} />;
  else if (!recommendation || !recommendation.mainCategoryCode)
    render = <NoData />;
  else
    render = t(
      taxonomy.RiskAssessmentCategory.byId[recommendation.mainCategoryCode]
        ?.code
    );

  return (
    <Row>
      <Label>{t("ram.recommendations.column.mainCategoryCode.label")}:</Label>
      {render}
    </Row>
  );
};
